import { render, staticRenderFns } from "./NoDataComponent.vue?vue&type=template&id=39b619ff"
import script from "./NoDataComponent.vue?vue&type=script&lang=js"
export * from "./NoDataComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports